import React, { useEffect } from 'react';

import { skillCategoryDomain, skillDomain } from 'models';
import { EditView } from 'components/Crud';
import { useDispatch } from 'react-redux';
import { useSkillCategoriesState } from 'store/selectors';
import { getDomainSlice } from 'store';
import { getSkillsInputFieldsProps, validationSchema } from './FormConfig';

function EditSkillView() {
  const dispatch = useDispatch();

  const { actions } = getDomainSlice(skillCategoryDomain);
  const {
    items: skillCategoriesData,
    isLoading,
    error
  } = useSkillCategoriesState();

  // TODO - temporary high page size values until FFT-612 is completed
  useEffect(() => {
    if (actions.changePagination) {
      dispatch(actions.changePagination({ pageIndex: 0, pageSize: 10000 }));
    }
  }, []);

  return (
    <EditView
      domain={skillDomain}
      fields={getSkillsInputFieldsProps('edit', skillCategoriesData)}
      validationSchema={validationSchema}
      loading={isLoading}
      error={error}
    />
  );
}

export default EditSkillView;
